// @flow
import React, { PureComponent } from 'react';
import styled from 'styled-components';

import Button from './Button';

type Props = {
  title: string,
};

const LabelStyle = styled.span`
  padding-top: 5px;
`;

class Button01 extends PureComponent<Props> {
  render() {
    const { title, ...rest } = this.props;
    return (
      <Button fullWidth {...rest}>
        <LabelStyle>{title}</LabelStyle>
      </Button>
    );
  }
}

export default Button01;



// WEBPACK FOOTER //
// /opt/build/repo/src/app/components/Button/Button01.js